
import { ClassNameMap } from "@material-ui/core/styles/withStyles";
import { getDisplayedPrice } from "../../engine/PriceUtilities";
import DataPanel from "../DataPanel";
import FormDetails from "./FormDetails";
import FormsCleanupButton from "./FormsCleanupButton";

interface Props {
  readonly customerId: number;
  readonly priceListId: number;
}

const columns = [
  {
    name: 'name',
    label: 'Nazwa',
  },
  {
    name: 'material',
    label: 'Materiał',
  },
  {
    name: 'price',
    label: 'Cena',
  },
  {
    name: 'dimension',
    label: 'Wymiary',
  },
  {
    name: 'weight',
    label: 'Waga',
  }
];

const FormsPanel = (props: Props) => {
  const customerId = props.customerId;
  const priceListId = props.priceListId;

  const renderCustomFormButtons = (
    buttonClasses: ClassNameMap,
    getSelectedIds: () => number[],
    fetchData: () => void,
    reportAlerts: (messages: string[]) => void
  ) => {
    return <FormsCleanupButton
      buttonClasses={ buttonClasses }
      customerId={ customerId }
      reportAlerts={ reportAlerts }
      refreshForms={ fetchData }
    />
  };

  return <>
    <DataPanel
      title='Formatki'
      resource={`customers/${customerId}/price-lists/${priceListId}/forms`}
      columns={columns}
      deleteRequiresConfirmation
      tableSearchEnabled
      renderDetails={(detailsProps) =>
        <FormDetails { ...{
          ...detailsProps,
          customerId: customerId,
          priceListId: priceListId
        }}/>}
      renderCustomButtons={ renderCustomFormButtons }
      convert={(data: any) => ({
        ...data,
        material: data.material.name,
        price: getDisplayedPrice(data.price),
        dimension: `${data.dimension.length} x ${data.dimension.width} x ${data.dimension.depth}`
      })}
    />
  </>;
};
export default FormsPanel;